import { Route } from 'react-router'
import { useLocation } from 'react-router-dom'
import { isAuthenticated } from '../api/auth/auth'
import { redirectToRoute } from '../utils/faceliftRedirectionRoutes'

const PrivateRoute = ({ component: Component, ...rest }) => {
  const isAuth = isAuthenticated()
  const location = useLocation()
  const paramId = rest.computedMatch.params

  // const redirectToRoute = (route, paramId) => {
  //   let faceliftRoute

  //   switch (route) {
  //     case '/cotacoes':
  //       faceliftRoute = `${process.env.REACT_APP_URL_MAIN}/Marketplacecliente/cotacoes`
  //       break
  //     case `/cotacoes/${paramId.idCotacao}`:
  //       faceliftRoute = `${process.env.REACT_APP_URL_MAIN}/MarketPlaceCliente/MinhaCotacao?id=${paramId.idCotacao}`
  //       break
  //     case '/negociacoes':
  //       faceliftRoute = `${process.env.REACT_APP_URL_MAIN}/Marketplacecliente/negociacoes`
  //       break
  //     case `/negociacoes/${paramId.idNegociacao}`:
  //       faceliftRoute = `${process.env.REACT_APP_URL_MAIN}/MarketPlaceCliente/MinhaNegociacao?id=${paramId.idNegociacao}`
  //       break
  //     case '/meus-pedidos':
  //       faceliftRoute = `${process.env.REACT_APP_URL_MAIN}/pedidos/lista?pedido=seu_pedido`
  //       break
  //     case `/meus-pedidos/${paramId.idPedido}`:
  //       faceliftRoute = `${process.env.REACT_APP_URL_MAIN}/MarketPlaceCliente/MeuPedido?id=${paramId.idPedido}`
  //       break
  //     case '/gimplus':
  //       faceliftRoute = `${process.env.REACT_APP_URL_MAIN}/Marketplacecliente/gimplus`
  //       break
  //     case '/':
  //       faceliftRoute = `${process.env.REACT_APP_URL_MAIN}/Marketplacecliente/meuperfil`
  //       break
  //     case '/meu-perfil':
  //       faceliftRoute = `${process.env.REACT_APP_URL_MAIN}/Marketplacecliente/meuperfil`
  //       break
  //     default:
  //       faceliftRoute = `${process.env.REACT_APP_URL_MAIN}/Marketplacecliente/meuperfil`

  //       break
  //   }

  //   return faceliftRoute
  // }

  return (
    <Route
      {...rest}
      render={(props) => {
        if (isAuth) {
          return <Component {...props} />
        } else {
          return (window.location.href = redirectToRoute(
            location.pathname,
            paramId
          ))
        }
      }}
    />
  )
}

export default PrivateRoute
